import { pathsV2Creators } from 'core/services/navigation/usePathsV2';
import { CandidateListTab } from 'modules/candidate-profile/stores/useCandidateListStore';

// Where users land when Home is hidden from them.
export const candidatesLandingPath = pathsV2Creators.CANDIDATE_PROFILE_LIST({
  searchParams: {
    tab: CandidateListTab.CANDIDATES
  }
});
